<template>
<el-dialog title="Import PDF" :visible.sync="modal" top="8vh" width="550px">
    <el-alert class="alert-info mt-n7 mb-2" type="info" title="Reminder" show-icon :closable="false" >   
        Kindly use <router-link to="/pdf-manipulator" target="_blank">PDF Merger</router-link> if you have multiple PDF files with 1 page only to save time and credits.
    </el-alert>
    <el-form :model="importForm" ref="importForm">
        <el-form-item prop="parserId" label="Parsers">
            <el-select v-model="importForm.parserId" placeholder="Select Parsers" style="width:100%;" clearable>
                <el-option v-for="(parser, index) in parsers" :key="index" :label="parser.parser_name" :value="parser.parser_id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="fileList" label="Template" class="mt-n2">
            <el-upload action="" :auto-upload="false" :show-file-list="false" :file-list="importForm.fileList" :multiple="false" :limit="2" :on-change="onChange">
                <el-input :value="filename" readonly style="width: 510px;">
                    <el-button slot="prepend" type="primary">Choose PDF File</el-button>
                </el-input>
            </el-upload>
        </el-form-item>
        <el-form-item class="mb-n3">
            <div style="float:right;">
                <el-button size="medium" type="danger" plain @click="handleCancel">Cancel</el-button>
                <el-button size="medium" style="" type="primary" :disabled="importloading" :loading="importloading" @click="handleImportPDF">Import</el-button>
            </div>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex';
import * as type from '../../../store/types';
import { PDFDocument } from 'pdf-lib'
export default {
    data: () => ({
        modal: false,
        importForm: {
            parserId: '',
            fileList: []
        },
        filename: '',
        notes: ''
    }),
    computed: {
        ...mapGetters({
            parsers: 'docparser/parsers',
            importloading: 'docparser/getImportLoading'
        })
    },
    created() {
        this.loadParsers()
    },
    methods: {
        ...mapActions({
            loadParsers: `docparser/${type.DP_GET_PARSERS}`,
            importPDF: `docparser/${type.DP_ADD_PARSED_RESULT}`
        }),
        async handleImportPDF() {
            if (!this.importForm.parserId || this.importForm.fileList.length === 0) {
                this.$message({
                    type: 'error',
                    message: 'Please select parser or PDF file first!'
                })
            } else {
                if (this.importForm.fileList[0].type !== 'application/pdf') {
                    return this.$message({ type: "error", message: "Please upload pdf file!" })
                }

                let payload = {
                    filename: this.filename,
                    myFile: this.importForm.fileList[0],
                    parserId: this.importForm.parserId,
                    userName: JSON.parse(localStorage.getItem('user')).user_name
                };
                this.importPDF(payload)
                    .then(() => this.modal = false)
            }
        },
        handleCancel() {
            this.importForm = {
                parserId: '',
                fileList: []
            };
            this.notes = '';
            this.handleModalView();
        },
        onChange(files, fileList) {
            this.importForm.fileList = [];
            this.importForm.fileList.push(files.raw);
            this.filename = files.name
        },
        handleModalView() {
            this.modal = !this.modal
        }
    }
}
</script>

<style scoped>
.alert-info{
    word-break: break-word;
}
</style>